import { render, staticRenderFns } from "./ModalEndorsement.vue?vue&type=template&id=21c30226"
import script from "./ModalEndorsement.vue?vue&type=script&lang=js"
export * from "./ModalEndorsement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports